/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetOcppConfigurationKeyDto } from './AssetOcppConfigurationKeyDto';
import {
    AssetOcppConfigurationKeyDtoFromJSON,
    AssetOcppConfigurationKeyDtoFromJSONTyped,
    AssetOcppConfigurationKeyDtoToJSON,
    AssetOcppConfigurationKeyDtoToJSONTyped,
} from './AssetOcppConfigurationKeyDto';

/**
 * 
 * @export
 * @interface AssetOcppConfigurationSnapshotDto
 */
export interface AssetOcppConfigurationSnapshotDto {
    /**
     * 
     * @type {Array<AssetOcppConfigurationKeyDto>}
     * @memberof AssetOcppConfigurationSnapshotDto
     */
    configurationKey: Array<AssetOcppConfigurationKeyDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetOcppConfigurationSnapshotDto
     */
    unknownKey: Array<string>;
    /**
     * Informational only. True when the response may be truncated by GetConfigurationMaxKeys. Never blocks persistence.
     * @type {boolean}
     * @memberof AssetOcppConfigurationSnapshotDto
     */
    possiblyIncomplete?: boolean;
}

/**
 * Check if a given object implements the AssetOcppConfigurationSnapshotDto interface.
 */
export function instanceOfAssetOcppConfigurationSnapshotDto(value: object): value is AssetOcppConfigurationSnapshotDto {
    if (!('configurationKey' in value) || value['configurationKey'] === undefined) return false;
    if (!('unknownKey' in value) || value['unknownKey'] === undefined) return false;
    return true;
}

export function AssetOcppConfigurationSnapshotDtoFromJSON(json: any): AssetOcppConfigurationSnapshotDto {
    return AssetOcppConfigurationSnapshotDtoFromJSONTyped(json, false);
}

export function AssetOcppConfigurationSnapshotDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetOcppConfigurationSnapshotDto {
    if (json == null) {
        return json;
    }
    return {
        
        'configurationKey': ((json['configurationKey'] as Array<any>).map(AssetOcppConfigurationKeyDtoFromJSON)),
        'unknownKey': json['unknownKey'],
        'possiblyIncomplete': json['possiblyIncomplete'] == null ? undefined : json['possiblyIncomplete'],
    };
}

export function AssetOcppConfigurationSnapshotDtoToJSON(json: any): AssetOcppConfigurationSnapshotDto {
    return AssetOcppConfigurationSnapshotDtoToJSONTyped(json, false);
}

export function AssetOcppConfigurationSnapshotDtoToJSONTyped(value?: AssetOcppConfigurationSnapshotDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configurationKey': ((value['configurationKey'] as Array<any>).map(AssetOcppConfigurationKeyDtoToJSON)),
        'unknownKey': value['unknownKey'],
        'possiblyIncomplete': value['possiblyIncomplete'],
    };
}

